import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

import { ArquivoValidator } from '@app/validators/arquivo.validator';
import { SisrhService } from '@app/services/sisrh.service';

import Swal from 'sweetalert2';

@Component({
  templateUrl: './upload-arquivo.component.html'
})
export class UploadArquivoComponent implements OnInit {

  @Input() idInscricao: string;
  @Input() idVagaRequisito: string;
  @Output() arquivoEvento = new EventEmitter();

  enviando = false;
  fgUploadArquivo: FormGroup;

  constructor(
    public ngbActiveModal: NgbActiveModal,
    private fb: FormBuilder,
    private sisrhService: SisrhService
  ) {



  }

  ngOnInit() {

    this.fgUploadArquivo = this.fb.group({
      idInscricao: this.idInscricao,
      idVagaRequisito: this.idVagaRequisito,
      comprovante: ['', [Validators.required, ArquivoValidator.tamanhoMaximo, ArquivoValidator.somentePdf]]
    });

  }

  get c() {

    return this.fgUploadArquivo.controls;

  }

  enviarArquivo() {

    this.enviando = true;

    if (this.fgUploadArquivo.invalid) {
      return;
    }

    Swal.fire({
      icon: 'warning',
      title: 'Aguarde..',
      text: 'Estamos enviando seu comprovante.',
      showConfirmButton: false,
      allowOutsideClick: false
    })

    this.sisrhService
      .incluirComprovante(this.fgUploadArquivo.value)
      .subscribe(
        x => {
          Swal.close();
          this.ngbActiveModal.close();
          this.arquivoEvento.emit(x);
        },
        e => {
          this.arquivoEvento.emit(e);
        }
      );

  }

  setArquivo(evento: any) {

    const arquivo = evento.target.files[0];
    this.c.comprovante.setValue(arquivo);

  }

}
